import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const ScrollCue = () => {
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const check = () => {
      const doc = document.documentElement;
      const left = doc.scrollHeight - window.scrollY - doc.clientHeight;
      // stays visible until the page is really scrolled to the very bottom
      setAtEnd(left < 8);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);

  const goDown = () => {
    window.__userScrolled = true;
    const step = document.documentElement.clientHeight * 0.85;
    const target = window.scrollY + step;
    if (window.__lenis) window.__lenis.scrollTo(target, { duration: 1.1 });
    else window.scrollTo({ top: target, behavior: "smooth" });
  };

  return (
    <motion.button
      type="button"
      data-testid="scroll-cue-button"
      onClick={goDown}
      aria-label="ادامه"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: atEnd ? 0 : 1, y: atEnd ? 10 : 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      style={{ pointerEvents: atEnd ? "none" : "auto" }}
      className="scroll-cue fixed inset-x-0 mx-auto w-fit z-50 flex items-center justify-center gap-2 h-11 px-5 rounded-full border border-[#C29B38]/70 bg-white/70 backdrop-blur text-[#3D362F] text-sm font-light shadow-[0_10px_30px_-18px_rgba(26,22,18,0.45)] transition-colors duration-300 hover:border-[#C29B38] hover:text-[#C29B38] active:scale-95"
    >
      <span>ادامه</span>
      <motion.span animate={{ y: [0, 5, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
        <ChevronDown size={16} />
      </motion.span>
    </motion.button>
  );
};
